<template>
    <LoginLayout>
        <div class="mb-0 LoginCard">
            <div class="card-body">
                <GenerateCode v-if="!user || !email" />
                <SetNewPassword v-else />
            </div>
        </div>
    </LoginLayout>
</template>

<script>

    import LoginLayout from "../../../views/layouts/LoginLayout";
    import GenerateCode from "../components/GenerateCode";
    import SetNewPassword from "../components/SetNewPassword";
    import store from "../store/store";
    import {RESET_STATE} from "../store/types";

    export default {
        name: "ResetPassword",
        components: {
            SetNewPassword,
            GenerateCode,
            LoginLayout
        },

        beforeRouteEnter: (to, from, next) => {
            store.dispatch(RESET_STATE);

            return next(vm => {
                if (to.query.email) {
                    vm.email = to.query.email;
                }
                if (to.query.code) {
                    vm.code = to.query.code;
                }
            });
        },

        computed: {
            ...store.mapState(['user']),
            ...store.mapFields(['email', 'code']),
        }
    }
</script>
